import React from 'react'
import { hasError, incomeAttributeMatcher, useFormErrorContext } from '../../../utils/context/FormErrorContext';
import { useTranslation } from 'react-i18next';
import ToolTip from '../../../components/common/ToolTip/ToolTip';
import AIRPNumberInput from '../../../components/common/AIRPNumberInput/AIRPNumberInput';
import IncomeAttributeTableFragmentGenerator from '../../../utils/TableGenerator/IncomeAttributeTableFragmentGenerator';
import IncomeAttributeLookupObject from '../../../types/lookups/IncomeAttributeLookupObject';
import { useShowIncomeLabel } from '../../../utils/ShowIncomeLabelContext';

interface ReserveForReplacementAllowanceTabProps {
    handleValueChange: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
    handleCommentChange: (value: string, name: string) => void,
    lookups: IncomeAttributeLookupObject[],
    incomeAttributes?: Record<string, unknown>[],
}


function ReserveForReplacementAllowanceTab(props: ReserveForReplacementAllowanceTabProps) {
    const { handleValueChange, handleCommentChange, lookups, incomeAttributes } = props
    const { t } = useTranslation(['pie', "navigation"]);
    const { errors } = useFormErrorContext()
    const { showIncomeLabel } = useShowIncomeLabel()

    const findAttributeData = (attributeCode: string) => {
        let incomeAttributesData: Record<string, unknown> | undefined = undefined;
        if (incomeAttributes) {
            incomeAttributesData = (incomeAttributes as Record<string, unknown>[]).find(({ code }) => code === attributeCode);
        }
        return incomeAttributesData;
    };

    return (
        <>
            {lookups &&
                <table className="table-with-border pie-table" role="presentation">
                    <thead>
                        <tr>
                            {showIncomeLabel && <th id="attribute-label" scope="col"></th>}
                            {showIncomeLabel && <th id="income-attribute-comment-header" scope="col"></th>}
                            <th id="income-attribute-value-header" scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {showIncomeLabel &&
                                <td className="padding-left-10 padding-right-10 narrow-label">
                                    <ToolTip placement={"bottom-start"} contents={t("reserveForReplacementAllowance", { ns: "navigation" })}>
                                        {t("tooltip.HTL.50")}
                                    </ToolTip>
                                </td>
                            }
                            <td className={hasError(errors, "50", incomeAttributeMatcher) ? "table-error" : ""}>
                                <AIRPNumberInput
                                    textAlign="right"
                                    name={"50"}
                                    ariaLabel={t("reserveForReplacementAllowance", { ns: "navigation" })}
                                    initialValue={findAttributeData("50") === undefined ? undefined : (findAttributeData("50") as Record<string, unknown>)["value"] as number}
                                    symbol="$"
                                    errorMatcher={incomeAttributeMatcher}
                                    onChange={(value, lastValue) => {
                                        handleValueChange?.(value, "income-attribute-50", lastValue)
                                    }} />
                            </td>
                        </tr>
                        <tr>
                            {showIncomeLabel &&
                                <th className="padding-left-10 padding-right-10">
                                    <ToolTip contents={t("reserve.items")}>
                                        {t("tooltip.HTL.50")}
                                    </ToolTip>
                                </th>
                            }
                            <th className="padding-left-10 padding-right-10"></th>
                        </tr>
                        {lookups.map((attr, key) => {
                            let incomeAttributesData: Record<string, unknown> | undefined = undefined;
                            if (incomeAttributes && (incomeAttributes as Record<string, unknown>[]).length > 0) {
                                incomeAttributesData = (incomeAttributes as Record<string, unknown>[]).find(({ code }) => code === attr.incomeAttributeCode);
                            }
                            if (attr.incomeAttributeCode === "114") {
                                return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                    data={incomeAttributesData} hasInputLabel={true} isPlaceHolderWithAttrDesc={true}
                                    valueChangeHandler={handleValueChange}
                                    handleCommentChange={handleCommentChange} isRequiredField={false} isCapitalCostsOrReplacementReserve={false}
                                    showSubheading={false} isOtherLabel={false} />
                            } else {
                                return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                    data={incomeAttributesData} hasInputLabel={false} valueChangeHandler={handleValueChange}
                                    handleCommentChange={handleCommentChange} isRequiredField={false} isCapitalCostsOrReplacementReserve={false}
                                    showSubheading={false} isOtherLabel={false} />
                            }
                        })
                        }
                    </tbody>
                </table>
            }
        </>
    )
}

export default ReserveForReplacementAllowanceTab